






































































import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

import {mapActions} from 'vuex';

@Component
export default class SignUp extends Vue {
  public $refs!: {
    form: any,
  };

  private user: any = {};
  private loading: boolean = false;
  @Getter('common/rules/all') private rules!: any;

  @Action('guest/auth/signUp') private storeSignUp!: (user: any) => Promise<boolean>;
  @Action('guest/auth/signIn') private storeSignIn!: (user: any) => Promise<boolean>;

  private async signUp(e: Event): Promise<void> {
    e.preventDefault();
    if (this.$refs.form.validate()) {
      this.loading = true;

      const success = await this.storeSignUp(this.user);

      if (success) {
        await this.storeSignIn(this.user);
        this.$router.push({name: 'UserBase'});
      }

      this.loading = false;
    }
  }
}
